<template>
  <div class="app-content ap monitors position-relative">

    <div
      class="position-absolute bg-white w-100 h-100 d-flex flex-column justify-content-center text-center align-items-center app__loading"
      v-if="isLoading"
    >
      <p><strong>Loading data...</strong></p>
      <b-spinner></b-spinner>
    </div>

    <b-row class="mb-4">
      <b-col cols="auto">
        <b-button :to="{ name: 'MonitorsDashboardSubCategory', params: { category: monitorCategory, tagId: monitorCurrent.tag.id }}" class="btn btn-secondary btn-svg" title="Back to Dashboard"><svg viewBox="0 0 492 492"><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></svg></b-button>
      </b-col>
      <b-col>
        <div class="d-flex h-100 w-100 flex-column justify-content-center">
          <h1 class="ap__main-title text-danger mb-2">{{ monitorCategory }} Insight Monitors</h1>
          <h5 class="font-weight-bold mb-0"><template v-if="monitorCurrent.tag.generation">{{ monitorCurrent.tag.generation }}</template><template v-else>{{ monitorCurrent.tag.sector }}</template> → {{ monitor.name }}</h5>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3">

        <MonitorStructure />

      </b-col>
      <b-col cols="9">
        <div class="chapters">
          <b-row class="mb-4">
            <b-col>
              <div class="chapters__title-block">
                <b-row>
                  <b-col>
                    <div class="chapters__title">Chapters</div>
                  </b-col>
                  <b-col cols="auto" class="d-flex align-items-center">
                    <router-link :to="{ name: 'MonitorsTrash', params: { type: 'chapters', tagId: monitorCurrent.tag.id }}" class="chapters__global-button" v-b-popover.hover.top="'Trash'">
                      <svg viewBox="0 0 480.052 480.052"><path d="M435.498,64.829c-2.248-1.089-4.876-1.066-7.105,0.064l-34.48,17.488l-26.984-46.352c-9.237-17.313-27.298-28.091-46.92-28H186.665c-19.909,0.048-38.353,10.472-48.664,27.504l-24.8,40.304c-2.292,3.724-1.17,8.598,2.52,10.944l88,56c1.282,0.815,2.769,1.247,4.288,1.248c0.664,0.001,1.325-0.083,1.968-0.248c2.135-0.541,3.953-1.939,5.024-3.864l33.6-60.456l36.8,69.6l-33.504,20.104c-2.942,1.764-4.432,5.208-3.704,8.56c0.725,3.351,3.505,5.867,6.912,6.256l119.064,13.536c0.3,0.032,0.602,0.048,0.904,0.048c3.066,0,5.863-1.752,7.2-4.512l56.936-117.536C441.135,71.54,439.474,66.755,435.498,64.829z M205.137,124.716l-74.184-47.2l20.72-33.664c7.401-12.267,20.666-19.782,34.992-19.824h32.48l19.824,39.8L205.137,124.716z M370.345,180.98l-89.984-10.232l19.768-11.864c3.639-2.188,4.935-6.837,2.952-10.592L237.377,24.028h82.632c13.895-0.02,26.648,7.688,33.088,20l30.784,52.904c2.137,3.656,6.752,5.013,10.528,3.096l20.048-10.16L370.345,180.98z"/><path d="M473.049,232.06l-25.856-51.648c-1.974-3.953-6.779-5.556-10.732-3.582c-0.159,0.079-0.315,0.164-0.468,0.254l-96,56c-3.762,2.194-5.077,6.994-2.96,10.8l33.376,60.144h-74.4v-32c0.002-4.418-3.579-8.001-7.997-8.003c-2.255-0.001-4.406,0.95-5.923,2.619l-80,88c-2.607,2.869-2.782,7.194-0.416,10.264l80,104c2.697,3.499,7.721,4.149,11.22,1.452c1.964-1.514,3.115-3.852,3.116-6.332v-24h56c19.726,0.486,37.977-10.407,46.912-28l56-95.952l16.64-26.88C482.324,271.813,482.893,249.98,473.049,232.06z M385.009,404.156c-6.164,12.51-19.059,20.275-33,19.872h-64c-4.418,0-8,3.582-8,8v8.48l-61.6-80.048l61.6-67.744v19.312c0,4.418,3.582,8,8,8h146.072L385.009,404.156z M457.921,280.812l-14.4,23.2h-54.808l-33.904-61.016l81.864-47.768l22.2,44.32C466.039,252.463,465.675,268.241,457.921,280.812z"/><path d="M191.273,244.676l-48-104c-1.38-3.006-4.467-4.854-7.768-4.648l-128,8c-4.41,0.274-7.763,4.07-7.489,8.48c0.161,2.588,1.565,4.938,3.769,6.304l0.008,0.016l39.552,24.528l-26.4,52.864c-9.569,17.385-9.514,38.472,0.144,55.808l44.52,76.88l24.344,42.168c10.455,17.76,29.448,28.746,50.056,28.952h32c4.418,0,8-3.582,8-8v-112c0-4.418-3.582-8-8-8h-59.768l39.904-69.24l32.992,12.704c4.124,1.585,8.753-0.473,10.338-4.597C192.25,248.88,192.177,246.637,191.273,244.676z M160.009,328.028v96h-24c-14.908-0.144-28.651-8.089-36.216-20.936l-21.96-38.048l22.656-37.016H160.009z M147.505,225.396c-3.676-1.412-7.833,0.06-9.8,3.472l-69.2,120.064l-37.568-64.904c-6.906-12.618-6.803-27.908,0.272-40.432l29.752-59.632c1.863-3.706,0.585-8.221-2.944-10.4l-24.472-15.136l97.496-6.072l37.44,81.12L147.505,225.396z"/></svg>
                    </router-link>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="auto">
              <div class="d-flex align-items-end h-100">
                <b-button variant="primary" v-b-modal.bv-modal-create-chapter>Create Chapter</b-button>
              </div>
            </b-col>
          </b-row>
          <MonitorChapterList
            :monitorId="monitor.id"
            :updateList="updateChaptersList"
            @chaptersFetched="updateChapters"
            @requestChapterEdit="requestChapterEdit"
          />
        </div> 
      </b-col>
    </b-row>

    <MonitorChapterCreate :chapters="chapters" @chapterCreated="requestChaptersUpdate" />
    <MonitorChapterEdit :chapter="chapterToEdit" @chapterEdited="requestChaptersUpdate" />

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { monitorsDataMixin } from '../mixins/monitorsDataMixin.js';

import MonitorStructure from "@/components/MonitorStructure";

import MonitorChapterList from "@/components/MonitorChapterList";
import MonitorChapterCreate from "@/components/MonitorChapterCreate";
import MonitorChapterEdit from "@/components/MonitorChapterEdit";

import {
  GLOBAL_CHANGE_SECTION,
  MONITOR_GET
} from "@/store/actions.type";

export default {
  name: 'MonitorsDetails',
  mixins: [monitorsDataMixin],
  components: {
    MonitorStructure,
    MonitorChapterList,
    MonitorChapterCreate,
    MonitorChapterEdit
  },
  data() {
    return {
      isLoading: true,
      monitor: {},
      chapters: {},
      updateChaptersList: false,
      chapterToEdit: {},
      updateStructureParagraphs: []
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "section", "monitorCategory", "monitorCurrent"])
  },
  methods: {
    async getMonitor() {
      await this.$store.dispatch(MONITOR_GET, this.$route.params.id).then((data) => {
        this.monitor = data;
      });
      this.isLoading = false;
    },
    updateChapters(chapters) {
      this.updateChaptersList = false;
      this.chapters = chapters;
    },
    requestChaptersUpdate() {
      this.updateChaptersList = true;
    },
    requestChapterEdit(chapter) {
      this.chapterToEdit =  Object.assign({}, chapter);
      this.$bvModal.show('bv-modal-edit-chapter');
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    if(this.section != 'monitors') {
      this.$store.dispatch(GLOBAL_CHANGE_SECTION, 'monitors');
      this.getMonitorsData();
    }

    this.getMonitor();
  }
}
</script>

<style lang="scss">
.chapters {

  &__title-block { 
    padding-bottom: rem(6px);
    border-bottom: 3px solid $color-genoa;
  }

  &__title {
    font-weight: 700;
    font-size: rem(28px);
  }

  &__global-button {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(26px);
      height: rem(26px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill: $color-java;
      }
    }
  }

  &__list {
    
  }
}
</style>